import editForm from "formiojs/components/select/Select.form";
import CustomSelectEditForm from "./form.data";

export default function (...extend) {
    return editForm([
        {key: 'logic', ignore: true},
        {key: 'layout', ignore: true},
        {
            key: 'api',
            ignore: false,
            components: [
                {"html":"<p>This is the internal name for the field. You do not need to set this, but it may be useful to know when setting up conditional fields or calculation logic.</p><p>Changing this can have <strong>major</strong> impacts on your program. Variables in notifiation templates and workflow configurations may be using the <code>Property Name</code> to access this data.</p>","label":"Content","refreshOnChange":false,"key":"content","type":"content","input":false,"tableView":false},
                {key: 'key', ignore: false, disabled: true},
                {key: 'tags', ignore: true},
                {key: 'properties', ignore: true},
            ],
        },
        {
            key: 'data',
            ignore: false,
            components: CustomSelectEditForm
        },
        {
            key: 'display',
            ignore: false,
            components: [
                { key: 'widget', ignore: true }, //The html5 one doesn't support search and choicesjs also looks better
                {key: 'customClass', ignore: true},
                {key: 'hidden', ignore: true},
                {key: 'mask', ignore: true}, // this is the 'Hide Input' checkbox, NOT the input mask field
                {key: 'tableView', ignore: true}, // specific to how you view this in the Form.io server admin UI
                {key: 'modalEdit', ignore: true}, // specific to how you view this in the Form.io server admin UI (I think)
            ],
        },
        {
            key: 'validation',
            ignore: false,
            components: [
                {key: 'unique', ignore: true},
                {key: 'custom-validation-js', ignore: true},
                {key: 'json-validation-json', ignore: false},
            ]
        }
    ], ...extend)
}
